<template>
  <div class="user-recover-pass-change_urc">

    <page-header>
      <nav-inner
          :links="[
          { url: '/user/authenticate', text: 'Войти' },
          { url: '/user/register', text: 'Регистрация' },
        ]"/>
    </page-header>

    <div v-if="showForm" class="page-container_pcr" @keyup.enter="submit">

      <app-inputs ref="inputs">

        <div class="block-wrap">

          <app-input
            widget="AppPassword"
            :options="{ name: 'password', title: 'Новый пароль', required: true,
            confirm: true, strength: true }"/>

          <div class="buttons-wrap">
            <button class="vivid-button" @click="submit">Изменить пароль</button>
          </div>

        </div>

      </app-inputs>

    </div>

    <div class="block-wrap" v-if="!showForm">
      <div class="buttons-wrap">
        <div style="margin-bottom: 30px;">Вы успешно изменили пароль.<br>
          Можете перейти к форме входа и воспользоваться им.</div>
        <button
            class="vivid-button"
            @click="$router.push({ path: '/user/authenticate' })">
          Перейти к форме входа</button>
      </div>
    </div>

    <page-footer/>

  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import PageHeader from '../PageHeader';
import PageFooter from '../PageFooter';
import NavInner from '../NavInner';
import AppInputs from '../inputs/AppInputs';
import AppInput from '../inputs/AppInput';

export default {

  components: { PageHeader, PageFooter, NavInner, AppInputs, AppInput },

  mounted() {
    const script = document.createElement('script');
    script.setAttribute('src', '/static/js/jsrsasign-all-min.js');
    document.head.appendChild(script);
  },

  data() {
    return {
      showForm: true,
    };
  },

  methods: {

    submit() {
      const hash = this.$route.params.hash;
      if (hash && !this.$refs.inputs.hasErrors()) {
        Vue.$loading.on();
        const { password } = this.$refs.inputs.getValues();
        const keysPair = window.GenerateKeysPair(password.password);
        const params = {
          hash,
          password: password.password,
          confirm: password.confirm,
          privateKey: keysPair[0],
          publicKey: keysPair[1],
        };
        axios.put('users/recover-pass/change', params).then(() => {
          this.showForm = false;
        }).catch(e => this.$notify.error(e.response.data))
          .finally(() => Vue.$loading.off());
      }
    },

  },

};
</script>

<style lang="scss">
.user-recover-pass-change_urc {
  .block-wrap {
    max-width: 700px;
  }
  .buttons-wrap {
    margin: 20px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/UserRecoverPassChange.vue